export const useTenantSettingsStore = defineStore('tenantSettingsStore', {
  state: () => ({
    taskDetailsBaseUrl: '',
    calendarShowOnItem: '' as string,
    projectDetailsBaseUrl: '',
    useUserSnap: false as boolean | undefined
  }),
  actions: {
    async fetchTenantSettings() {
      const tenantSettings = (await useApi('tenant/settings', 'GET')).data

      this.calendarShowOnItem = tenantSettings.calendarShowOnItem

      this.taskDetailsBaseUrl = tenantSettings.use_suite_task_detailpage
        ? `${window.location.origin}/tasks`
        : TASK_DETAILS_LINK

      this.projectDetailsBaseUrl = tenantSettings.use_suite_project_detailpage
        ? `${window.location.origin}/project`
        : PROJECT_DETAILS_LINK

      this.useUserSnap = tenantSettings.useUserSnap === '1'
    }
  }
})
